import React, { Component } from "react";
import { Form, Input, Select } from "antd";
import { connect } from "react-redux";
import style from "./list.module.sass";
import { Http } from "../../../../helpers/axois";
import { pushToast } from "../../../../stateManager/store/toast/actions";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

interface State {
  serviceName?: string;
  displayName?: string;
  displayNameErr?: string;
  serviceNameErr: string;
  langauge?: string;
  selectedJourney?: any;
  soloServiceName?: any;
  soloServiceLanguage?: any;
  soloDisplayName?: any;
  // isServiceType: any;
}

interface Props {
  onSubmit: (submit: () => void) => void;
  appId?: any;
  versionId?: any;
  getSoloService: (res: any) => void;
  editInitialData?: any;
  editSoloIntitialData?: any;
  editable?: boolean;
  setvisible?: (visible: boolean) => void;
  pushToast?: (data: any) => void;
  currentBranch?: any;
  selectedService?: any;
  editType: string;
}

class AppService extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      // isServiceType: ((this.props.editInitialData === undefined) && (this.props.editSoloIntitialData === undefined) && this.props.selectedService === null) ? true : false,
      selectedJourney: this.props.editType || this.props.selectedService || "Assisted",
      serviceName: this.props.editSoloIntitialData && this.props.editSoloIntitialData.name ? this.props.editSoloIntitialData.name : "",
      displayName: this.props.editSoloIntitialData && this.props.editSoloIntitialData.displayName ? this.props.editSoloIntitialData.displayName : "",
      displayNameErr: "",
      serviceNameErr: "",
      langauge: this.props.editSoloIntitialData && this.props.editSoloIntitialData.language ? this.props.editSoloIntitialData.language : "javascript",
      soloServiceLanguage: this.props.editSoloIntitialData && this.props.editSoloIntitialData.language ? this.props.editSoloIntitialData.language : "javascript",
      soloServiceName: this.props.editSoloIntitialData && this.props.editSoloIntitialData.name ? this.props.editSoloIntitialData.name : ""
    };
    this.props.onSubmit(this.onSubmit);
  }

  onSubmit = () => {
    if ((this.state.serviceName && this.state.displayName) || (this.state.soloServiceName)) {
      let { editable, editSoloIntitialData } = this.props;
      if (!editable) {
        this.saveSoloServices();
      } else {
        this.updateSoloService(editSoloIntitialData.id)
      }
    } else {
      this.setState({ serviceNameErr: "required" });
      this.setState({ displayNameErr: "required" });
    }
  };

  // saveService() {
  //   const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
  //   const data = {
  //     name: this.state.serviceName,
  //     displayName: this.state.displayName,
  //     appId: this.props.appId,
  //     versionId: this.props.versionId,
  //     lang: this.state.langauge,
  //     topicName: this.state.serviceName,
  //     branchId: currentBranchId
  //   };
  //   const { getService, setvisible } = this.props;
  //   Http.post("services", data).subscribe(
  //     (res) => {
  //       this.props.pushToast && this.props.pushToast({ type: "success", message: "Service saved successfully" });
  //       getService(res);
  //       setvisible && setvisible(false);
  //     },
  //     (err) => {
  //       if (err && err.code === "23505") {
  //         this.props.pushToast && this.props.pushToast({ type: "error", message: "Service name already Exists" });
  //       } else {
  //         this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Service save failed" });
  //       }
  //       setvisible && setvisible(false);
  //     }
  //   );
  // }

  saveSoloServices() {
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    const data = {
      name: this.state.soloServiceName,
      versionId: this.props.versionId,
      language: this.state.soloServiceLanguage,
      branchId: currentBranchId
    }
    const { getSoloService, setvisible } = this.props;
    Http.post(`apps/${this.props.appId}/solo-services`, data).subscribe(
      (res) => {
        this.props.pushToast && this.props.pushToast({ type: "success", message: "Service saved successfully" });
        getSoloService(res)
        setvisible && setvisible(false);
      },
      (err) => {
        if (err && err.code === "23505") {
          this.props.pushToast && this.props.pushToast({ type: "error", message: "Service name already Exists" });
        } else {
          this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Service save failed" });
        }
        setvisible && setvisible(false);
      }
    );
  }

  // updateService(serviceId?: string) {
  //   const { getService, setvisible } = this.props;

  //   const data = {
  //     name: this.state.serviceName,
  //     displayName: this.state.displayName,
  //     appId: this.props.appId,
  //     versionId: this.props.versionId
  //   };
  //   Http.put(`/services/${serviceId}`, data).subscribe(
  //     (res) => {
  //       this.props.pushToast && this.props.pushToast({ type: "success", message: "Service updated successfully" });
  //       getService(res);
  //       setvisible && setvisible(false);
  //     },
  //     (err) => {
  //       this.props.pushToast && this.props.pushToast({ type: "error", message: err && err.message ? err.message : "Service Updataion failed" });
  //       setvisible && setvisible(false);
  //     }
  //   );
  // }

  updateSoloService(soloServiceId: any) {
    const { getSoloService, setvisible } = this.props;
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
    const data = {
      name: (this.state.soloServiceName || (this.props.editSoloIntitialData && this.props.editSoloIntitialData.name)),
      language: this.state.soloServiceLanguage,
      versionId: this.props.versionId,
      branchId: currentBranchId
    };
    Http.put(`/apps/${this.props.appId}/solo-services/${soloServiceId}`, data).subscribe(
      (res) => {
        this.props.pushToast && this.props.pushToast({ type: "success", message: "Service updated successfully" });
        getSoloService(res);
        setvisible && setvisible(false);
      },
      (err) => {
        this.props.pushToast && this.props.pushToast({ type: "error", message: err.error ? err.error : "Service Updation failed" });
        setvisible && setvisible(false);
      }
    );

  }
  render() {
    let { editInitialData, editSoloIntitialData } = this.props;
    let { displayNameErr } = this.state;
    const languageDisable = (editSoloIntitialData || editInitialData) ? true : false;
    return (
      <div>
        {<Form {...formItemLayout} className={style.app + " override-content"}>
          {/* <Form.Item
            validateStatus={displayNameErr && "error"}
            help={displayNameErr}
            label={<span className={style.labelName}>Display Name</span>}
          >
            <Input
              data-test-id="service_display_name"
              defaultValue={editSoloIntitialData && editSoloIntitialData.displayName}
              onChange={(e) => this.setState({ soloDisplayName: e.target.value.trim().replace(/ /g, "_"), displayNameErr: "" })}
            />
          </Form.Item> */}
          <Form.Item
            validateStatus={displayNameErr && "error"}
            help={displayNameErr}
            label={<span className={style.labelName}>Name</span>}
          >
            <Input
              data-test-id="service_display_name"
              defaultValue={editSoloIntitialData && editSoloIntitialData.name}
              onChange={(e) => this.setState({ soloServiceName: e.target.value.trim().replace(/ /g, "_"), displayNameErr: "" })}
            />
          </Form.Item>
          <Form.Item label={<span className={style.labelName}>Language</span>}>
            <Select data-test-id="service_language" disabled={languageDisable} value={this.state.soloServiceLanguage} onChange={(e: any) => this.setState({ soloServiceLanguage: e })}>
              <Option data-test-id="service_javascript" value="javascript">JavaScript</Option>
              <Option data-test-id="service_typescript" value="typescript">TypeScript</Option>
            </Select>
          </Form.Item>
        </Form>}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentBranch: state.apps.appBranch,
    selectedService: state.solo.selectedService
  }
}

export default connect(mapStateToProps, { pushToast })(AppService);
